// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

.box {
  padding: 0.8rem 1.333rem;
  font-weight: 500;
  color: #CFE7ED;
  position: relative;
  border-radius: 0.667rem;
  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
}
.box.first {
  width: 28rem;
  height: 16rem;
}
.box.first .text-topic {
  color: var(--color-primary-blue);
  font-size: 0.833rem;
  margin-bottom: 0.5rem;
  min-height: 3.5rem;
}
.box.second {
  width: 28rem;
  height: 22.5rem;
}
.box.second .text-topic {
  color: var(--color-primary-blue);
  font-size: 0.833rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  letter-spacing: 0;
  line-height: 1.333rem;
  margin-top: 0.258rem;
}
.box .info {
  position: relative;
  margin-bottom: 2rem;
}
.box .info .infoBackground {
  height: 4rem;
  border-radius: 0.667rem;
  background: #FFFFFF linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.08) 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.box .info .text {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 100%;
  color: var(--color-primary-blue);
}
.box .buttons {
  display: flex;
  justify-content: space-evenly;
}
.box .choose-one {
  color: var(--color-red_line-red);
  font-size: 0.75rem;
}
.box .correctAnswer {
  background: #FFFFFF linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.08) 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
  width: 100%;
  height: 4rem;
  color: var(--color-primary-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.667rem;
}
.box .correctAnswer.red-line {
  border: 0.083rem solid var(--color-red_line-red);
}

.boxPlayerPopup {
  height: 19rem !important;
}
.boxPlayerPopup ion-item {
  margin-bottom: 0.3rem;
}
.boxPlayerPopup .sb11:before {
  bottom: 0.042rem;
}

.playerPopup {
  height: 3.5em;
  padding: 0.1rem;
  font-weight: 500;
  color: #CFE7ED;
  position: relative;
  border-radius: 0.667rem;
  margin-top: 0.5rem;
  background: #FFFFFF linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.08) 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}

.sb11:before {
  content: "";
  width: 0;
  height: 0;
  border-top: 0 solid transparent;
  border-bottom: 2rem solid transparent;
  border-left: 2rem solid #CFE7ED;
  transform: rotateZ(270deg);
  position: absolute;
  right: -1rem;
  bottom: 0;
}

.playerPopup:before {
  content: "";
  width: 0;
  height: 0;
  border-top: 0 solid transparent;
  border-bottom: 2rem solid transparent;
  border-left: 2rem solid #FFFFFF;
  transform: rotateZ(90deg);
  position: absolute;
  left: -1.3rem;
  top: 0;
}

.correct {
  --ion-item-background: green;
  color: white !important;
}

.wrong {
  --ion-item-background: red;
  color: white !important;
}

ion-list {
  background: transparent;
}
ion-list ion-item {
  height: 3.5rem;
  min-height: 3.5rem;
  border-radius: 0.667rem;
  background: #FFFFFF linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.08) 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
  font-size: 0.833rem;
  font-weight: 500;
  color: var(--color-primary-blue);
}
ion-list ion-item .input-wrapper {
  height: 2rem;
}
ion-list ion-item ion-checkbox {
  margin: 0;
  --size: 0.7rem;
}
ion-list ion-item ion-label {
  height: 3.5rem;
  display: flex;
  align-items: center;
  margin: 0 0 0 0.3rem;
}

ion-list > label {
  font-size: 0.833rem;
  font-weight: 500;
  color: var(--color-primary-blue);
}

ion-list:not(:last-child) ion-item {
  margin-bottom: 0.3rem;
}

.avatar-col {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: 20%;
  margin-top: 7rem;
}
.avatar-col .avatar-box {
  position: relative;
  height: 11rem;
  display: flex;
  justify-content: center;
  width: 5rem;
}
.avatar-col .avatar-box .avatar {
  width: 6rem;
  position: absolute;
  z-index: 2;
  margin-left: 1rem;
}
.avatar-col .avatar-box .avatar svg {
  width: 100%;
}
.avatar-col .avatar-box .avatar img {
  width: 100%;
}
.avatar-col .avatar-box .floor-box {
  position: absolute;
  width: 6rem;
  bottom: 0;
}

.start-btn {
  width: 11.708rem;
  height: 2.667rem;
  min-height: 2.667rem;
  --min-height: 2.667rem;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/quiz-game/quiz-game.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,oGAAA;AACF;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEI;EACE,gCAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AAAN;AAIE;EACE,YAAA;EACA,eAAA;AAFJ;AAII;EACE,gCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;AAFN;AAQE;EACE,kBAAA;EACA,mBAAA;AANJ;AAQI;EACE,YAAA;EACA,uBAAA;EACA,0FAAA;EACA,yCAAA;AANN;AASI;EACE,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;AAPN;AAWE;EACE,aAAA;EACA,6BAAA;AATJ;AAYE;EACE,gCAAA;EACA,kBAAA;AAVJ;AAaE;EACE,0FAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AAXJ;AAaI;EACE,gDAAA;AAXN;;AAgBA;EACE,wBAAA;AAbF;AAeE;EACE,qBAAA;AAbJ;AAgBE;EACE,gBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0FAAA;EACA,yCAAA;AAfF;;AAkBA;EAYE,WAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,qCAAA;EACA,+BAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,qCAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;AA1BF;;AA6BA;EACE,4BAAA;EACA,uBAAA;AA1BF;;AA6BA;EACE,0BAAA;EACA,uBAAA;AA1BF;;AA6BA;EACE,uBAAA;AA1BF;AA4BE;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,0FAAA;EACA,yCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;AA1BJ;AA4BI;EACE,YAAA;AA1BN;AA6BI;EACE,SAAA;EACA,cAAA;AA3BN;AA8BI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AA5BN;;AAiCA;EACE,mBAAA;EACA,gBAAA;EACA,gCAAA;AA9BF;;AAkCE;EACE,qBAAA;AA/BJ;;AAmCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAhCF;AAkCE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAhCJ;AAkCI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAhCN;AAkCM;EACE,WAAA;AAhCR;AAmCM;EACE,WAAA;AAjCR;AAqCI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAnCN;;AAwCA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,eAAA;AArCF","sourcesContent":["ion-content {\n  --background: transparent;\n}\n\n.box {\n  padding: 0.8rem 1.333rem;\n  font-weight: 500;\n  color: #CFE7ED;\n  position: relative;\n  border-radius: 0.667rem;\n  background: #CFE7ED linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n  //box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset;\n\n  &.first {\n    width: 28rem;\n    height: 16rem;\n\n    .text-topic {\n      color: var(--color-primary-blue);\n      font-size: 0.833rem;\n      margin-bottom: 0.5rem;\n      min-height: 3.5rem;\n    }\n  }\n\n  &.second {\n    width: 28rem;\n    height: 22.5rem;\n\n    .text-topic {\n      color: var(--color-primary-blue);\n      font-size: 0.833rem;\n      font-weight: bold;\n      margin-bottom: 0.5rem;\n      letter-spacing: 0;\n      line-height: 1.333rem;\n      margin-top: 0.258rem;\n      //min-height: 3.5rem;\n    }\n  }\n\n\n  .info {\n    position: relative;\n    margin-bottom: 2rem;\n\n    .infoBackground {\n      height: 4rem;\n      border-radius: 0.667rem;\n      background: #FFFFFF linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.08) 100%);\n      box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n    }\n\n    .text {\n      position: absolute;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      left: 50%;\n      width: 100%;\n      color: var(--color-primary-blue);\n    }\n  }\n\n  .buttons {\n    display: flex;\n    justify-content: space-evenly;\n  }\n\n  .choose-one {\n    color: var(--color-red_line-red);\n    font-size: 0.75rem;\n  }\n\n  .correctAnswer {\n    background: #FFFFFF linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.08) 100%);\n    box-shadow: 0 2px 0 0 rgb(0 0 0 / 16%);\n    width: 100%;\n    height: 4rem;\n    color: var(--color-primary-blue);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.667rem;\n\n    &.red-line {\n      border: 0.083rem solid var(--color-red_line-red);\n    }\n  }\n}\n\n.boxPlayerPopup {\n  height: 19rem !important;\n\n  ion-item {\n    margin-bottom: 0.3rem;\n  }\n\n  .sb11:before {\n    bottom: 0.042rem\n  }\n}\n\n.playerPopup {\n  height: 3.5em;\n  padding: 0.1rem;\n  font-weight: 500;\n  color: #CFE7ED;\n  position: relative;\n  border-radius: 0.667rem;\n  margin-top: 0.5rem;\n  background: #FFFFFF linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.08) 100%);\n  box-shadow: 0 2px 0 0 rgb(0 0 0 / 16%);\n}\n\n.sb11:before {\n  //\n  //content: '';\n  //position: absolute;\n  //left: 42%;\n  //top: 100%;\n  //width: 0;\n  //height: 0;\n  //border-left: 20px solid transparent;\n  //border-right: 20px solid transparent;\n  //border-top: 20px solid #CFE7ED;\n  //clear: both;\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 0 solid transparent;\n  border-bottom: 2rem solid transparent;\n  border-left: 2rem solid #CFE7ED;\n  transform: rotateZ(270deg);\n  position: absolute;\n  right: -1rem;\n  bottom: 0;\n}\n\n.playerPopup:before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-top: 0 solid transparent;\n  border-bottom: 2rem solid transparent;\n  border-left: 2rem solid #FFFFFF;\n  transform: rotateZ(90deg);\n  position: absolute;\n  left: -1.3rem;\n  top: 0;\n}\n\n.correct {\n  --ion-item-background: green;\n  color: white !important;\n}\n\n.wrong {\n  --ion-item-background: red;\n  color: white !important;\n}\n\nion-list {\n  background: transparent;\n\n  ion-item {\n    height: 3.5rem;\n    min-height: 3.5rem;\n    border-radius: 0.667rem;\n    background: #FFFFFF linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.08) 100%);\n    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n    font-size: 0.833rem;\n    font-weight: 500;\n    color: var(--color-primary-blue);\n\n    .input-wrapper {\n      height: 2rem;\n    }\n\n    ion-checkbox {\n      margin: 0;\n      --size: 0.7rem;\n    }\n\n    ion-label {\n      height: 3.5rem;\n      display: flex;\n      align-items: center;\n      margin: 0 0 0 0.3rem;\n    }\n  }\n}\n\nion-list > label {\n  font-size: 0.833rem;\n  font-weight: 500;\n  color: var(--color-primary-blue);\n}\n\nion-list:not(:last-child) {\n  ion-item {\n    margin-bottom: 0.3rem;\n  }\n}\n\n.avatar-col {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  width: 20%;\n  margin-top: 7rem;\n\n  .avatar-box {\n    position: relative;\n    height: 11rem;\n    display: flex;\n    justify-content: center;\n    width: 5rem;\n\n    .avatar {\n      width: 6rem;\n      position: absolute;\n      z-index: 2;\n      margin-left: 1rem;\n\n      svg {\n        width: 100%;\n      }\n\n      img {\n        width: 100%;\n      }\n    }\n\n    .floor-box {\n      position: absolute;\n      width: 6rem;\n      bottom: 0;\n    }\n  }\n}\n\n.start-btn {\n  width: 11.708rem;\n  height: 2.667rem;\n  min-height: 2.667rem;\n  --min-height: 2.667rem;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
